import React, {Component} from 'react';
const { connect } = require('react-redux');


import '../sass/popularsearches.scss';

import Footer from '../components/Footer';
import HeaderPopularSearches from '../components/popularsearches/HeaderPopularSearches';
import ListPopularSearches from '../components/popularsearches/ListPopularSearches';


class PopularSearches extends Component
{
    constructor(props) {
        super(props);
        this.state = {}
    }
    componentDidMount() {

    }
    render()
    {
        return (
            <div id="wrapper">
                <HeaderPopularSearches />
                <ListPopularSearches />
                <Footer />
            </div>
        )
    }
}

export default connect(
    state => ({

    }),({

    })
)(PopularSearches)


// WEBPACK FOOTER //
// ./src/containers/PopularSearches.js